module.exports = __webpack_public_path__ + "img/mamedly.6fe35edf.jpg";